<wtf-dialogcontent [size]="'md'" class="mat-dialog-content-form-programado" [dialogTitle]="title" (closeModal)="close()"
    [action]="action">

    <form [formGroup]="templateForm" class="tax-type-form w-100-p" fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="end center">
            <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
        </div>
        <div>
            <mat-label>{{ "templateName" | translate }}*</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <input maxlength="20" matInput name="name" #name formControlName="name" mat-maxlength="50"
                    placeholder="" [readonly]="action === recordAction.View" required />
                <mat-hint align="start">{{ name.value?.length || 0 }}/20
                    {{ "caracteres" | translate }}</mat-hint>
            </mat-form-field>
        </div>
        <div>
            <mat-label>{{ "templateContent" | translate }}*</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <textarea matInput #input maxlength="160" name="content" [readonly]="action === recordAction.View"
                    formControlName="content" placeholder="">
                </textarea>
                <mat-hint align="start">{{ input.value?.length || 0 }}/160
                    {{ "caracteres" | translate }}</mat-hint>
            </mat-form-field>

        </div>
        <div>
            <mat-label>{{ "Codigo Corto" | translate }}*</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-select [compareWith]="compareFn" name="shortCode" formControlName="shortCode" placeholder=""
                    required>
                    <mat-option *ngFor="let shortCode of shortCodes" [value]="shortCode">{{
                        shortCode.operator.name + " - " + shortCode.value
                        }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-label>{{ "Grupos" | translate }}*</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-select name="groups" formControlName="groups" [compareWith]="compareFn" placeholder="" multiple>
                    <mat-option *ngFor="let grupo of grupos" [value]="grupo">{{ grupo.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-label translate>TagMT</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <input matInput #input maxlength="50" name="service_type" [readonly]="action === recordAction.View"
                    formControlName="service_type" placeholder="" />
            </mat-form-field>
        </div>
        <div>
            <mat-checkbox disabled name="instantaneo" [checked]="hasURL" (change)="hasUrl($event)">{{
                "Agregar URL" | translate
                }}</mat-checkbox>

            <div *ngIf="hasURL">
                <mat-label>{{ "URL" | translate }}*</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <input matInput #input maxlength="150" name="message" [readonly]="action === recordAction.View"
                        formControlName="longUrl" placeholder="" />
                </mat-form-field>
            </div>
        </div>
        <br>

    </form>
</wtf-dialogcontent>